var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-layout"},[_vm._t("default"),_vm._v(" "),(_vm.customBody)?[_vm._t("body")]:(_vm.$slots.body)?_c('div',{staticClass:"s-layout__body"},[_vm._t("body")],2):_vm._e(),_vm._v(" "),(_vm.$slots.footer)?_c('footer',{staticClass:"s-layout__footer"},[_vm._t("footer")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }